import { Icon, InputRightElement } from '@podiumhq/design-system';

export const FormFieldRightIcon = ({
  fillColor = 'silver.light',
  isButtonIcon,
  onClick,
  size,
  variant = 'ghost',
  ...props
}) => {
  const iconProps = {
    onClick,
    size,
    variant,
    ...(onClick && { cursor: 'pointer' }),
    ...props,
  };

  return (
    <InputRightElement mt={size === 'lg' ? '5px' : '0'} size={size}>
      <Icon sx={{ svg: { fill: fillColor } }} {...iconProps} />
    </InputRightElement>
  );
};
